import type { ServiceRequest } from "@medplum/fhirtypes";
import { SERVICE_REQUEST_COLLECTION_NAME } from "../../fhir";
import { createSubscriptionHook } from "./create-subscription-hook";

export const useServiceRequestSubscription = createSubscriptionHook<ServiceRequest>(
  "ServiceRequest",
  SERVICE_REQUEST_COLLECTION_NAME,
);
